import { gql } from "apollo-boost"

export const createEquipmentAttachment = gql`
  mutation createEquipmentAttachment($data: CreateEquipmentAttachmentInput!) {
    CreateEquipmentAttachment(data: $data)
  }
  `